module.exports = "https://coursera_assets.s3.amazonaws.com/images/6cc25816a32e177a424a030f7b09a5cb.png";